(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easy-quote-demo"] && !Shopify.designMode) return;
  try {
    
  let eqLightboxScrollY = 0;

  function eqLightboxLockScroll() {
    eqLightboxScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${eqLightboxScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function eqLightboxUnlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, eqLightboxScrollY);
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest('[data-eq-lightbox-open]');
    if (trigger) {
      event.preventDefault();
      const dialog = document.getElementById(trigger.getAttribute('data-eq-lightbox-open'));
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
      eqLightboxLockScroll();
      dialog.addEventListener('close', eqLightboxUnlockScroll, { once: true });
      dialog.showModal();
      return;
    }
    if (target instanceof HTMLDialogElement && target.classList.contains('eq-demo__lightbox')) {
      target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
